/* eslint-disable unused-imports/no-unused-vars */
import React from 'react';
import { Box, Slider} from '@mui/material';
import Typography from '@/components/typography/typography';
import AlignmentControl from './AlignmentControl';

interface CodeControlsProps {
  // type: 'qr-code' | 'bar-code';
  attrs: Record<string, any>;
  updateAttrs: (attr: Record<string, any>) => void;
}

const CodeControls: React.FC<CodeControlsProps> = ({
  // type,
  attrs,
  updateAttrs,
}) => {
  const { styles } = attrs

  const updateStyles = (styles: Record<string, any>) => {
    updateAttrs({ styles });
  }

  const handleAlignmentChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null,
  ) => {
    if (newAlignment !== null) {
      updateStyles({ textAlign: newAlignment });
    }
  };

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Typography type="s3" color='theme.neutral.800'>
          Size (px)
        </Typography>
        <Slider
          value={styles.fontSize}
          onChange={(_, value) =>  updateStyles({ fontSize: value as number })}
          min={10}
          max={25}
          step={5}
          valueLabelDisplay="auto"
          size="small"
          sx={(theme) => ({
            '& .MuiSlider-rail': {
              color: theme.palette.theme.primary[500],
            },
            '& .MuiSlider-thumb': {
              color: theme.palette.theme.primary[800],
            },
            '& .MuiSlider-track': {
              color: theme.palette.theme.primary[600],
            },
          })}
        />
      </Box>
      <AlignmentControl alignment={styles?.textAlign} onAlignmentChange={handleAlignmentChange} displayLabel/>
    </>
  );
};

export default CodeControls;